module.exports = __webpack_public_path__ + "img/plane.e378b7f6.png";